import { render } from "./TradeListSkeleton.vue?vue&type=template&id=465081f4&scoped=true"
import script from "./TradeListSkeleton.vue?vue&type=script&lang=js"
export * from "./TradeListSkeleton.vue?vue&type=script&lang=js"

import "./TradeListSkeleton.vue?vue&type=style&index=0&id=465081f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465081f4"]])

export default __exports__